import { createFeature } from '@ngrx/store';
import { DOCUMENT_TYPES_REDUCER, SUBMISSION_TYPES_REDUCER } from '../reducer';

export const CONFIGURATION_DOCUMENT_FEATURE_STATE = createFeature({
  name: 'configurations-document',
  reducer: DOCUMENT_TYPES_REDUCER,
});

export const CONFIGURATION_SUBMISSION_FEATURE_STATE = createFeature({
  name: 'configurations-submission',
  reducer: SUBMISSION_TYPES_REDUCER,
});
